import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { Achievement } from '@/models/reward';
import { Routes } from '@/router';
import { LoyaltyExplainerModalState } from '@/components/modals/CmgLoyaltyExplainerModal/cmg-loyalty-explainer-modal';

@Component({
  name: 'CmgRewardsExtrasHeader',
})
export default class CmgRewardsExtrasHeader extends Vue {
  @Prop({ required: true, type: Array })
  achievements!: Achievement[];

  mounted() {
    this.$services.featureFlags.refreshApimFeatureFlags();
  }

  get description(): string {
    return 'Activate your Extras to earn extra points and collect Badges. ';
  }

  get title(): string {
    return 'BADGES';
  }

  get achievementsDescriptionLine1(): string {
    return 'When you earn badges, you can find them here. ';
  }

  get achievementsDescriptionLine2(): string {
    return 'Activate an Extra to start earning badges!';
  }  

  get extrasIconUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionExtras.default;
  }

  get placeholderBadgeUrl(): string {
    return this.$appStore.state.cms.images.icons.extrasBadgePlaceholderNonExtrasOptinEnabled.default;
  }

  get placeHolderBadgeAnimationUrl(): string {
    return this.$appStore.state.cms.images.icons.extrasBadgePlaceholder.default;
  }

  get numPlaceholders(): number {
    return this.numAchievements >= 3
      ? 0
      : 3 - this.numAchievements;
  }

  get numAchievements(): number {
    return this.achievements.length;
  }

  get hasAchievements(): number {
    return this.achievements.length;
  }

  get totalExtraPoints(): number {
    return this.$appStore.state.reward.totalExtraPoints;
  }

  onClickViewAll() {
    this.$router.push({ name: Routes.RewardsAchievements });
  }

  onClickAboutExtras() {
    this.$services.ui.setModalVisibility('rewardExtrasExplainer', true);
  }
}
